export default __webpack_public_path__ + "media/titles/title_free_account-99a6f198.png";